export const DetailDescriptionSkeleton = () => (
  <section
    className={
      "mt-6 grid animate-pulse grid-cols-2 gap-6 rounded-[2rem] bg-surface-container-high p-8 max-xl:flex max-xl:flex-col max-xl:gap-4 max-lg:mx-4 max-lg:mt-3 max-lg:rounded-[1.25rem] max-lg:p-4"
    }
  >
    <article>
      <div className="h-[2rem] w-1/3 animate-pulse rounded bg-surface-container-high max-xl:w-1/2"></div>
      <div className="mt-6 space-y-4 max-xl:mt-3">
        <div className="h-6 w-full animate-pulse rounded bg-surface-container-high max-xl:h-4"></div>
        <div className="h-6 w-3/4 animate-pulse rounded bg-surface-container-high max-xl:h-4"></div>
        <div className="h-6 w-2/4 animate-pulse rounded bg-surface-container-high max-xl:h-4"></div>
      </div>
    </article>

    <div>
      <div className="h-[2rem] w-1/3 animate-pulse rounded bg-surface-container-high max-xl:w-1/2"></div>
      <div className="mt-8 space-y-6 max-xl:mt-3">
        <div className="flex items-center justify-between border-b border-b-surface-container-high py-3">
          <div className="h-4 w-1/4 animate-pulse rounded bg-surface-container-high"></div>
          <div className="h-4 w-1/3 animate-pulse rounded bg-surface-container-high"></div>
        </div>
        {Array(4)
          .fill(null)
          .map((_, index) => (
            <div
              key={index}
              className="flex items-center justify-between border-b border-b-surface-container-high py-3"
            >
              <div className="h-4 w-1/4 animate-pulse rounded bg-surface-container-high"></div>
              <div className="h-4 w-1/3 animate-pulse rounded bg-surface-container-high"></div>
            </div>
          ))}
      </div>
    </div>
  </section>
);

export const DetailHeroSkeleton = () => (
  <div className="relative mt-6 aspect-[1880/764] animate-pulse rounded-[1.875rem] bg-surface-container-high max-md:hidden"></div>
);
